import { Component, OnInit } from "@angular/core";
import { RelatorioService } from "../../services/relatorio.services";
import { AuthService } from "src/app/services/ajs-auth.service";
import { MatDialog, MatSnackBar } from "@angular/material";
import { ModalExcluirComponent } from "../excluir/excluir-relatorio.component";
import { ModalCriarComponent } from "../criar/criar-relatorio.component";
import { ModalEditarComponent } from "../editar/editar-relatorio.component";
import { find, orderBy } from "lodash";

@Component({
  selector: "mandae-relatorio-automatizado-listar",
  templateUrl: "./listar-relatorio.component.html",
  styleUrls: ["./listar-relatorio.component.scss"]
})
export class ListarRelatorioComponent implements OnInit {
  public clienteId = 0;

  public currentCliente = [];

  public relatorios: any = [];

  constructor(
    public relatorioService: RelatorioService,
    public authService: AuthService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar
  ) {
    this.clienteId = this.authService.getCurrentUser()
      ? this.authService.getCurrentUser().id
      : 0;
  }

  public ngOnInit() {
    this.getPerfilUsuario();
    this.getRelatorios();
  }

  public async getRelatorios() {
    try {
      const data = await this.relatorioService.consultarRelatorio(
        this.clienteId
      );

      if (data) {
        this.relatorios = orderBy(data, ["id"], ["desc"]);
      }
    } catch (error) {}
  }

  public handleBotaoCriar() {
    const modal = this.dialog.open(ModalCriarComponent, {
      width: "500px",
      closeOnNavigation: false,
      disableClose: true,
      panelClass: "modal-notificacao-relatorio"
    });

    modal.afterClosed().subscribe(response => {
      if (response.status) {
        this.snackBar.open("Relatório criado com sucesso", "", {
          duration: 3000
        });

        this.getRelatorios();
      }
    });
  }

  public handleBotaoEditar(id: number) {
    const object = find(this.relatorios, { id });

    const modal = this.dialog.open(ModalEditarComponent, {
      width: "500px",
      closeOnNavigation: false,
      disableClose: true,
      panelClass: "modal-notificacao-relatorio",
      data: object
    });

    modal.afterClosed().subscribe(response => {
      if (response.status) {
        this.snackBar.open("Relatório atualizado com sucesso", "", {
          duration: 3000
        });

        this.getRelatorios();
      }
    });
  }

  public handleBotaoExcluir(id: number) {
    const modal = this.dialog.open(ModalExcluirComponent, {
      width: "260px",
      closeOnNavigation: false,
      disableClose: true,
      panelClass: "modal-notificacao"
    });

    modal.afterClosed().subscribe(response => {
      if (response) {
        this.excluirRelatorio(id);
      }
    });
  }

  public getPeriodo(periodo) {
    if (periodo > 1) {
      return `Ùltimos ${periodo} dias`;
    }
    return `Diária`;
  }

  public getPeriodicidade(agenda: any) {
    if (agenda[0].dia) {
      return `Mensal - Todo dia ${agenda[0].dia}`;
    }

    if (agenda.length === 7) {
      return "Diário";
    }

    if (agenda.length) {
      let semana = "Domingo";
      switch (agenda[0].semana) {
        case 1:
          semana = "Segunda-Feira";
          break;
        case 2:
          semana = "Terça-Feira";
          break;
        case 3:
          semana = "Quarta-Feira";
          break;
        case 4:
          semana = "Quinta-Feira";
          break;
        case 5:
          semana = "Sexta-Feira";
          break;
        case 6:
          semana = "Sábado";
          break;
      }
      return `Semanal - ${semana}`;
    }
  }

  public getSituacao(situacao: string) {
    switch (situacao) {
      case "EmDevolucao":
        return "Em Devolução";
      case "Extraviada":
        return "Extraviada";
      default:
        return "Todas";
    }
  }

  public async getPerfilUsuario() {
    try {
      const data = await this.relatorioService.consultaClientePrincipal(
        this.authService.getCurrentUser()
          ? this.authService.getCurrentUser().id
          : 0
      );

      this.currentCliente = data;
    } catch (error) {}
  }

  private async excluirRelatorio(id) {
    try {
      await this.relatorioService.excluirRelatorio(id);
      this.getRelatorios();
      this.snackBar.open("Relatório excluído com sucesso", "", {
        duration: 3000
      });
    } catch (error) {
      this.snackBar.open("Houve um erro ao excluir o relatório", "Ok");
    }
  }
}
